<template>

  <!-- Button Banners Block -->
  <div
    class="button-banners-block">

    <!-- 123 -->

  </div>

</template>

<script>

  export default {
    name: 'button-banners-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
  };

</script>

<style lang="scss">

  .button-banners-block {
    color: inherit;
  }

</style>
